import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {Assignee} from '../components/AssigneePicker'
import type {
  updateIssueAssigneesMutation,
  updateIssueAssigneesMutation$data,
} from './__generated__/updateIssueAssigneesMutation.graphql'

export function commitUpdateIssueAssigneesMutation({
  environment,
  input: {issueId, assignees, participants},
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {issueId: string; assignees: Assignee[]; participants: Assignee[]}
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueAssigneesMutation$data) => void
}) {
  // merge assignees and participants into one, unique by login and take the first 5
  const newParticipants = [...new Map([...assignees, ...participants].map(item => [item.login, item])).values()].slice(
    0,
    5,
  )

  return commitMutation<updateIssueAssigneesMutation>(environment, {
    mutation: graphql`
      mutation updateIssueAssigneesMutation($input: UpdateIssueInput!) @raw_response_type {
        updateIssue(input: $input) {
          issue {
            id
            assignees(first: 20) {
              edges {
                node {
                  ...AssigneePickerAssignee
                }
              }
            }
            participants(first: 5) {
              edges {
                node {
                  ...AssigneePickerAssignee
                }
              }
            }
          }
        }
      }
    `,
    variables: {input: {id: issueId, assigneeIds: assignees.map(a => a.id)}},
    optimisticResponse: {
      updateIssue: {
        issue: {
          id: issueId,
          assignees: {
            edges: assignees.map(a => {
              return {
                node: {
                  id: a.id,
                  login: a.login,
                  name: a.name,
                  avatarUrl: a.avatarUrl,
                },
              }
            }),
          },
          participants: {
            edges: newParticipants.map(a => {
              return {
                node: {
                  id: a.id,
                  login: a.login,
                  name: a.name,
                  avatarUrl: a.avatarUrl,
                },
              }
            }),
          },
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
